import React, { useEffect, useState } from 'react';
import { FormikProps } from 'formik';
import { FormDetailModel } from 'types/FormTypes';
import { useIovationFingerprint } from 'hooks/useIovationFingerprint';
import LoadingIndicator from 'components/atomic/LoadingIndicator';
import StarRating from 'components/atomic/StarRating';
import FormImage from './FormImage';

type FormUserReviewProps = {
  formData: FormDetailModel;
  formRef: FormikProps<any> | null;
  name: string;
  updateFormField: (name: string, value: any) => void;
};

const FormUserReview: React.FC<FormUserReviewProps> = ({
  formData,
  formRef,
  name,
  updateFormField,
}) => {
  const [rating, setRating] = useState<number>(0);
  const { initializeIovation } = useIovationFingerprint();

  useEffect(() => {
    initializeIovation();
    if (formRef?.values[name]) setRating(formRef?.values[name] || 0);
    formRef?.validateForm();
  }, [initializeIovation]);

  const updateRating = (value: number) => {
    setRating(value);
    updateFormField(name, value);
  };

  return formRef ? (
    <div className='w-full h-full flex flex-col justify-start px-3 overflow-auto'>
      {formData.image && (
        <FormImage image={formData.image} alt='form-question-image' />
      )}
      <h5
        tabIndex={0}
        className={`text-left text-lg leading-formTitle font-semibold text-black ${
          !formData.subText ? 'mb-3' : 'mb-0'
        }`}
      >
        {formData.text}
      </h5>
      {formData.subText && (
        <p
          tabIndex={0}
          className='mt-1.5 mb-3 text-left text-xs font-semibold leading-formSubtitle text-muted'
        >
          {formData.subText}
        </p>
      )}
      <StarRating rating={rating} setRating={updateRating} styles='!my-3' />
    </div>
  ) : (
    <LoadingIndicator />
  );
};

export default FormUserReview;
